import { initializeSegmentClients } from '@/segment/integration/segment-registry';
import { logToConsole } from '@/utils/logging';

try {
  initializeSegmentClients();
} catch (error: unknown) {
  logToConsole('Segment initialization failed:', error);
}
